import React from "react";

import { templates } from "@reactivated";

import { PageSkeleton } from "../components/PageSkeleton";

export const Template = (props: templates.ExamplePageTemplate) => (
    <PageSkeleton {...props.page}></PageSkeleton>
);
